import { defineSlotRecipe } from '@chakra-ui/react';
import { popoverAnatomy } from '@chakra-ui/react/anatomy';

export type ThemeGenPopoverConfig = {};

export const generatePopoverRecipe = (_: ThemeGenPopoverConfig) => {
  return defineSlotRecipe({
    slots: popoverAnatomy.keys(),
    base: {
      body: {
        padding: '8px'
      },
      footer: {
        display: 'flex',
        justifyContent: 'flex-end',
        borderTopWidth: '1px',
        padding: '4px 8px'
      }
    }
  });
};
